import React from 'react'
import './more-students-popup.css'

const MoreStudentsPopup = (props) => {

    const continueWithProcess = (theBool) => {
        if(theBool) {
            props.setView('availability')
            props.setWantsMoreStudentsPopup(false)
        } else {
            props.setOpenUpTheTimesheet(true)
            props.setWantsMoreStudentsPopup(false)
        }
    }

    const cancelProcess = () => {
        props.setOpenUpTheTimesheet(false)
        props.setWantsMoreStudentsPopup(false)
        props.setTryingToSubmitTimesheet(false)
    }

    return(
        <div className="more-students-popup__wrapper">
            <div className="more-students-popup">
                <h4>Do you want more students?</h4>
                {props.wantsMoreStudents ? <h5 className="more-students-popup__text">I want more students</h5> : <h5 className="more-students-popup__text">I'm Full</h5>}
                <div className="more-students-popup__switch-wrapper">
                    {!props.wantsMoreStudents && <svg style={{cursor: 'pointer'}} className="new-teacher-portal__switch-svg" viewBox="0 0 511.999 511.999" onClick={() => props.sendWantsMoreStudentsSwitch(true)}>
                        <g>
                        	<g>
                        		<path fill="rgb(255, 100, 100)" d="M376.499,120.5h-241C60.784,120.5,0,181.286,0,256s60.784,135.5,135.499,135.5h241c74.715,0,135.5-60.785,135.5-135.5
                        			S451.214,120.5,376.499,120.5z M135.499,361.501C77.326,361.501,30,314.173,30,256c0-58.173,47.326-105.5,105.499-105.5
                        			c58.173,0,105.5,47.327,105.5,105.5C240.999,314.173,193.672,361.501,135.499,361.501z"/>
                        	</g>
                        </g>
                    </svg>}
                    {props.wantsMoreStudents && <svg style={{cursor: 'pointer'}} className="new-teacher-portal__switch-svg" viewBox="0 0 512 512" onClick={() => props.sendWantsMoreStudentsSwitch(false)}>
                        <g>
                        	<g>
                        		<path fill="rgba(0, 128, 0, 0.8)" d="M376.5,120.5h-241C60.785,120.5,0,181.285,0,256s60.785,135.5,135.5,135.5h241c74.715,0,135.5-60.785,135.5-135.5
                        			S451.215,120.5,376.5,120.5z M376.5,361.5C318.327,361.5,271,314.174,271,256c0-58.172,47.327-105.5,105.5-105.5
                        			c58.173,0,105.5,47.328,105.5,105.5C482,314.174,434.673,361.5,376.5,361.5z"/>
                        	</g>
                        </g>
                    </svg>}
                </div>
                {props.wantsMoreStudents ? <div onClick={() => continueWithProcess(true)} className="more-students-popup__btn">Continue</div> : <div onClick={() => continueWithProcess(false)} className="more-students-popup__btn">Continue</div>}
                <div className="more-students-popup__cancel" onClick={() => cancelProcess()}>cancel</div>
            </div>
        </div>
    )
}
export default MoreStudentsPopup